import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText } from 'lucide-react';

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-gray-100 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Card className="border-0 shadow-xl">
          <CardHeader>
            <div className="flex items-center gap-3 mb-2">
              <FileText className="w-8 h-8 text-orange-500" />
              <CardTitle className="text-3xl">Condiciones de Uso</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none">
            <h2>1. Objeto</h2>
            <p>
              Las presentes Condiciones Generales de Uso regulan el acceso y utilización del sitio web 
              de Strategos Overland, que el titular pone gratuitamente a disposición de los usuarios de Internet.
            </p>

            <h2>2. Condiciones de Acceso y Utilización</h2>
            <p>
              El acceso y utilización del sitio web tiene carácter gratuito para los usuarios. No obstante, 
              algunos de los servicios y contenidos ofrecidos por Strategos Overland pueden encontrarse sujetos 
              a la contratación previa del servicio.
            </p>

            <h3>2.1. Usuario Registrado</h3>
            <p>
              Con carácter general la prestación de los servicios no exige la previa suscripción o registro de 
              los usuarios. Sin embargo, algunos servicios están condicionados a la inscripción como usuario registrado.
            </p>

            <h3>2.2. Veracidad de la Información</h3>
            <p>
              Toda la información que facilite el usuario deberá ser veraz. A estos efectos, el usuario garantiza 
              la autenticidad de los datos comunicados a través de los formularios para la suscripción de los servicios.
            </p>

            <h2>3. Obligaciones del Usuario</h2>
            <p>El usuario se compromete a:</p>
            <ul>
              <li>Hacer un uso adecuado y lícito del sitio web</li>
              <li>No realizar actividades ilícitas o contrarias a la buena fe</li>
              <li>No difundir contenidos delictivos, violentos, pornográficos, racistas, xenófobos o difamatorios</li>
              <li>No causar daños en los sistemas físicos y lógicos de Strategos Overland</li>
              <li>No introducir o difundir virus informáticos o programas perjudiciales</li>
            </ul>

            <h2>4. Responsabilidades</h2>
            <p>
              Strategos Overland no se hace responsable de los daños y perjuicios que pudieran derivarse de:
            </p>
            <ul>
              <li>Interferencias, interrupciones, fallos, omisiones, averías telefónicas, retrasos o desconexiones</li>
              <li>Errores u omisiones en los contenidos</li>
              <li>Uso no autorizado del sitio web</li>
              <li>Fallos de seguridad o daños producidos por terceros mediante intromisiones no autorizadas</li>
            </ul>

            <h2>5. Modificaciones</h2>
            <p>
              Strategos Overland se reserva el derecho a modificar en cualquier momento las presentes 
              Condiciones Generales de Uso, así como cualesquiera otras condiciones generales o particulares.
            </p>

            <h2>6. Duración y Terminación</h2>
            <p>
              La prestación del servicio del sitio web tiene una duración indefinida. Sin perjuicio de lo anterior, 
              Strategos Overland está autorizado para dar por terminada o suspender la prestación del servicio.
            </p>

            <h2>7. Legislación Aplicable</h2>
            <p>
              Las presentes Condiciones Generales de Uso se rigen por la legislación española.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
